/**
 * Created by mac on 12/28/20
 */

const GeneratorSourceMine = {
    prize: function (level, unit) {
        let prizes = GeneratorSourceMine.regular(unit);

        const hungryGamesDrop = HungryGamesCustomer.calcMineDrop(unit.getData().mineable.tasks[level].energy);
        if (hungryGamesDrop > 0) {
            prizes = [{
                amount: hungryGamesDrop,
                units: [{ code: "hungrygames", stage: 0 }]
            }].concat(prizes);
        }

        if (level === unit.getData().mineable.tasks.length - 1) {
            prizes = prizes.concat(GeneratorSourceMine.finalBonus());
        }

        return prizes;
    },

    regular: function (unit) {
        return [{
            amount: [3, 6],
            probabilities: [0.45, 0.25, 0.05, 0.15, 0.1],
            units: [
                { code: `${unit.getResource()}source`, stage: 0 },
                { code: `${unit.getResource()}source`, stage: 1 },
                { code: `${unit.getResource()}source`, stage: 2 },
                { code: unit.getResource(), stage: 0 },
                { code: unit.getResource(), stage: 1 }
            ]
        }];
    },

    finalBonus: function () {
        return [{
            amount: [4, 6],
            probabilities: [0.65, 0.25, 0.1],
            units: [
                { code: "coins", stage: 0 },
                { code: "coins", stage: 1 },
                { code: "rubies", stage: 0 }
            ]
        }];
    }
};
